import { html, property } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './section-header-group.lit.scss';

/**
 * @component {kat-section-header-group} KatSectionHeaderGroup <code>Section header group</code> creates a single container with multiple sections underneath. Each section has a <a href="/design-system/components/section-header">section header</a> for a title, and can contain free-form body content. This component is useful, as an example, for displaying small sets of details related to a specific item. For example, you may use it to display details about a single entity (a shipment, an order, etc), grouped into individual sections.
 * @example Default { "content": "<kat-section-header header=\"Section A\"><p>Content A</p></kat-section-header><kat-section-header header=\"Section B\"><p>Content B</p></kat-section-header><kat-section-header header=\"Section C\"><p>Content C</p></kat-section-header><kat-section-header header=\"Section D\"><p>Content D</p></kat-section-header><kat-section-header header=\"Section E\"><p>Content E</p></kat-section-header><kat-section-header header=\"Section F\"><p>Content F</p></kat-section-header><kat-section-header header=\"Section G\"><p>Content G</p></kat-section-header><kat-section-header header=\"Section H\"><p>Content H</p></kat-section-header>" }
 */
@register('kat-section-header-group')
export class KatSectionHeaderGroup extends KatLitElement {
  static get styles() {
    return [baseStyles, styles];
  }

  /** Number of columns at XXL breakpoint. See `Grid` component for default. */
  @property({ attribute: 'cols-xxl' })
  colsXXL?: number;

  /** Number of columns at XL breakpoint. See `Grid` component for default. */
  @property({ attribute: 'cols-xl' })
  colsXL?: number;

  /** Number of columns at L breakpoint. See `Grid` component for default. */
  @property({ attribute: 'cols-l' })
  colsL?: number;

  /** Number of columns at M breakpoint. See `Grid` component for default. */
  @property({ attribute: 'cols-m' })
  colsM?: number;

  /** Number of columns at S breakpoint. See `Grid` component for default. */
  @property({ attribute: 'cols-s' })
  colsS?: number;

  render() {
    return html`<kat-grid
      part="grid"
      ?cols-xxl=${this.colsXXL}
      ?cols-xl=${this.colsXL}
      ?cols-l=${this.colsL}
      ?cols-m=${this.colsM}
      ?cols-s=${this.colsS}
      ><slot></slot
    ></kat-grid>`;
  }
}
